var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSecurePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "44px",
    viewBox: "0 0 36 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Secure-Payment-big") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 L0,8 L0,20 C0,31.1 7.68,41.48 18,44 C28.32,41.48 36,31.1 36,20 L36,8 L18,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WIP-//-HUB-Payment-v1---Pre-Payment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_V1_Pay-Now_MakeDeposit-Blank",
    transform: "translate(-972.000000, -541.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-information",
    transform: "translate(818.000000, 517.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Secure-Payment-big",
    transform: "translate(154.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#29AAFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#8FD1FD",
    mask: "url(#mask-2)",
    x: -1,
    y: 0,
    width: 19,
    height: 44
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "8.82 21.18 6 24 14 32 30 16 27.18 13.16 14 26.34"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurePayment);
export default __webpack_public_path__ + "static/media/icon-secure-payment.c5a427f269fd2843f1bd99f092e918c0.svg";
export { ForwardRef as ReactComponent };